import {combineReducers, configureStore} from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import createSagaMiddleware from 'redux-saga'
import {middleware as sagaThunkMiddleware} from 'redux-saga-thunk'
// SYSTEM
import {economyPlannerReducer} from './economyPlanner/reducer'
import {entityReducer} from './entity/reducer'
import {flowReducer} from './flow/reducer'
import {promptReducer} from './prompt'
import {rootSaga} from './saga'

const sagaMiddleware = createSagaMiddleware({
  onError: (err) => {
    console.log('Error in Sagas', err)
    Sentry.captureException(err)
  },
})

const rootReducer = combineReducers({
  // SYSTEM
  economyPlanner: economyPlannerReducer,
  entity: entityReducer,
  flow: flowReducer,
  prompt: promptReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaThunkMiddleware, sagaMiddleware),
})

sagaMiddleware.run(rootSaga)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
